import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  setTheme: (t: Theme) => void
  toggle: () => void
}

function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem('velanox-theme', theme)
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      setTheme: (theme) => { applyTheme(theme); set({ theme }) },
      toggle: () => {
        const next = get().theme === 'light' ? 'dark' : 'light'
        applyTheme(next)
        set({ theme: next })
      },
    }),
    {
      name: 'velanox-theme-store', // separate key from the raw string
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(state.theme)
      },
    }
  )
)

// Apply theme on import using raw key (set by init script and setTheme)
try {
  const raw = localStorage.getItem('velanox-theme')
  // raw is either 'light', 'dark', or null
  if (raw === 'light' || raw === 'dark') applyTheme(raw)
  else applyTheme('light')
} catch {}
